<template>
  <div class="ml-4 flex flex-col">
    <template v-if="isFieldOneOfAddressTypes(fieldName)">
      <span class="font-semibold text-gray-500">
        {{
          wordsFirstLetterToUpper(
            `${details[CORRECT_FIELD_TYPES[fieldName.toLowerCase()]]}`,
            "_"
          )
        }}
      </span>
    </template>
    <div v-for="(value, key) in details" v-else :key="key" class="my-1">
      <span v-if="valueIsPrimitive(value)" class="font-semibold text-gray-500">
        {{ wordsFirstLetterToUpper(key, "_") }}:
        <span class="font-normal">
          {{ wordsFirstLetterToUpper(`${value}`, "_") }}
        </span>
      </span>
      <div v-else>
        <span class="font-semibold text-gray-500">
          {{ wordsFirstLetterToUpper(key, "_") }}:
        </span>
        <kyc-details-recursive :details="value" />
      </div>
    </div>
  </div>
</template>

<script>
import { wordsFirstLetterToUpper } from "@/helpers/formatting";

const CORRECT_FIELD_TYPES = {
  zipcode: "zip",
  city: "city",
  state: "state",
};

export default {
  name: "KycDetailsRecursive",
  props: {
    details: {
      type: [Object, null],
      required: true,
    },
    fieldName: {
      type: String,
      default: "",
    },
  },
  setup() {
    return {
      valueIsPrimitive,
      wordsFirstLetterToUpper,
      isFieldOneOfAddressTypes,
      CORRECT_FIELD_TYPES,
    };
  },
};

function valueIsPrimitive(val) {
  // array is prototyped from object as well
  return typeof val !== "object";
}

function isFieldOneOfAddressTypes(name) {
  return ["zip", "city", "state", "zipcode"].includes(name);
}
</script>
